import type { DraftRefsTarget } from "../useDraftRefsByTarget";

/** What a row drag carries to the task chat: what it holds and how to add it. */
export interface ChatDragItem {
    /** Singular item noun for the preview chip, e.g. "transaction". */
    noun: string;
    count: number;
    /** Adds the dragged items to the given composer. */
    add: (target: DraftRefsTarget) => void;
    /** Runs after a successful drop, e.g. to clear a carried selection. */
    onAdded?: () => void;
}

export function isChatDragItem(
    value: object | undefined,
): value is ChatDragItem {
    return (
        value !== undefined &&
        "noun" in value &&
        typeof value.noun === "string" &&
        "count" in value &&
        typeof value.count === "number" &&
        "add" in value &&
        typeof value.add === "function" &&
        (!("onAdded" in value) ||
            value.onAdded === undefined ||
            typeof value.onAdded === "function")
    );
}
